import { render, staticRenderFns } from "./OrderDispatch.vue?vue&type=template&id=3fa8c2f6&"
import script from "./OrderDispatch.vue?vue&type=script&lang=js&"
export * from "./OrderDispatch.vue?vue&type=script&lang=js&"
import style0 from "./OrderDispatch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports